var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("autocomplete", {
    attrs: {
      matches: ["DEFAULT"].concat(_vm.ancestryOptions),
      labelFormatter: (val) => _vm.labelText(val),
      placeholder: _vm.labelText(_vm.$store.state.selectedAncestry),
    },
    on: {
      "item-select": function ($event) {
        return _vm.onAncestrySelected($event)
      },
    },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }